export default __webpack_public_path__ + "static/media/32_desktop.7c3248ef.jpg";